// extracted by mini-css-extract-plugin
export default {"activateBall":"activateBall_OcZcI","disabled":"disabled_yGkDc"};